import {
  TERMINAL_CHART_SUMMARY,
  TERMINAL_CHART_SUMMARY_SUCCESS,
  TERMINAL_CHART_SUMMARY_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalChartSummaryReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_CHART_SUMMARY:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_CHART_SUMMARY_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_CHART_SUMMARY_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    default:
      return state;
  }
};

export default terminalChartSummaryReducer;
